<template>
	<div class="approval-view">
		<div class="approval" v-for="(appr, i) in value" :key="i">
			<div class="header">
				<div>{{ appr.name }}</div>
				<div class="status" v-if="!appr.state" style="background-color: #ffcf00; color: black;">Afventer</div>
				<div class="status" v-if="appr.state" style="background-color: #00C017;">Godkendt</div>
			</div>
			<text-view style="margin-top: 10px;" v-model="appr.remarks" />
			<div v-if="$store.state.employee.id == appr.employee_id && !appr.state" class="btn" @click.stop="approve(i)">Godkend</div>
			<div v-if="!appr.state" class="btn" @click.stop="remove(i)">Fjern</div>
		</div>
		<div class="btn" @click.stop="add">Tilføj</div>
	</div>
</template>

<script>
	import ResourcePopupView from '../views/ResourcePopupView'

	export default {
		data() {
			return {
				employees: []
			};
		},
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		watch: {
			value: {
				handler(n) {
					// If check var is missing add it
					var r = Array.from(n);
					var update = false;

					for (var i = 0; i < r.length; ++i) {
						if (!r[i].hasOwnProperty('state')) {
							r[i].state = r[i].approved !== null;
							update = true;
						}

						if (!r[i].hasOwnProperty('database')) {
							r[i].database = true;
							update = true;
						}
					}

					if (update) {
						this.$emit('input', r);
					}
				},
				deep: true
			}
		},
		methods: {
			add() {
				

				var self = this;

				this.$store.state.popupController.toggle(ResourcePopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 0,
					resources: this.employees.map(function (item) {
						return {
							label: 	item.name,
							id: 	item.id,
							type: 	'employee'
						}
					}),
					callback(type, id, label) {
						
						var r = Array.from(self.value);

						r.push({
							name: label,
							employee_id: id,
							database: false,
							state: false,
							remarks: ''
						});

						self.$emit('input', r);
					}
				});
			},
			remove(idx) {
				
				var r = Array.from(this.value);
				r.splice(idx, 1);
				this.$emit('input', r);
			},
			approve(idx) {
				
				var r = Array.from(this.value);
				r[idx].state = true;
				this.$emit('input', r);
			}
		},
		async created() {
			this.employees = (await this.axios.get('/employees/')).data._items;
		}
	}
</script>

<style lang="scss" scoped>
	.approval-view {
		& > .approval {
			position: relative;
			border: 1px solid #2d2f36;
			line-height: 30px;
			text-align: left;
			padding: 5px 5px 5px 5px;
			margin-bottom: 10px;
			cursor: pointer;

			& > .header {
				position: relative;

				& > .status {
					position: absolute;
					right: 5px;
					top: 5px;
					padding: 0 5px 0 5px;
					font-size: 14px;
					line-height: 20px;
				}
			}

			& > .btn {
				background-color: #202127;
				line-height: 40px;
				text-align: center;
				margin: 5px 0 0 0;
				cursor: pointer;
			}
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>